import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import router from './router'
import Antd, { Form } from 'ant-design-vue';
import ResizeTable from './components/Common/components/ResizeTable.vue'
import {instance,get,post,postForm,fileDownload} from './Utils/axios.js'
// import NsTrack from "ns-track/dist/ns-track.umd"
import 'ant-design-vue/dist/antd.css';
import store from './store/index.js'
import './Utils/numberExtend.js'
import './Utils/index.js'
import './assets/css/style.scss'
import { initTrack } from './Utils/initTrack'
// import NsTrack from './Utils/track';
// import {trackUrl,appCode} from './Utils/url'

let timer = null
if(!timer){
  timer = setInterval(() => {
    const user = JSON.parse(window.localStorage.getItem("userInfo"));
    if(user){
      initTrack(Vue)
      clearInterval(timer)
    }
  }, 500);
}
// initTrack(Vue)
// import {trackUrl} from '@/Utils/url.js'
// console.log('trackUrl',trackUrl)

Vue.use(Antd);
Vue.use(Form)
Vue.component('resize-table', ResizeTable)
Vue.use(Router)
Vue.prototype.$http = instance
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$postFrom = postForm
Vue.prototype.$fileDownload = fileDownload
Vue.config.productionTip = false

// Vue.use(NsTrack)
// 埋点
// const user = JSON.parse(window.localStorage.getItem("userInfo")) || {};
// const { userName, userId, email, code: userNo, userType, phoneNumber, clientId, } = user;
// Vue.use(NsTrack, {
//   appCode,
//   global: true,
//   url: trackUrl,
//   userInfo: {userName,userId,email,userNo,userType,phoneNumber,clientId},
// })


export default new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
